import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvUsers = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const users = await stbApi.getHubCsvUsers(clientSid);
  return users;
};
